module.exports = __webpack_public_path__ + "static/media/twitter.dc703c58.svg";